"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _RpcNDSNeo3_network;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcNDSNeo3 = void 0;
const neon_dappkit_1 = require("@cityofzion/neon-dappkit");
class RpcNDSNeo3 {
    constructor(network) {
        _RpcNDSNeo3_network.set(this, void 0);
        __classPrivateFieldSet(this, _RpcNDSNeo3_network, network, "f");
    }
    hasToken({ contractHash, address }) {
        return __awaiter(this, void 0, void 0, function* () {
            const parser = neon_dappkit_1.NeonParser;
            const invoker = yield neon_dappkit_1.NeonInvoker.init({ rpcAddress: __classPrivateFieldGet(this, _RpcNDSNeo3_network, "f").url });
            try {
                const result = yield invoker.testInvoke({
                    invocations: [
                        {
                            scriptHash: contractHash,
                            operation: 'balanceOf',
                            args: [
                                {
                                    type: 'Hash160',
                                    value: address,
                                },
                            ],
                        },
                    ],
                });
                return parser.parseRpcResponse(result.stack[0], { type: 'Integer' }) > 0;
            }
            catch (_a) {
                throw new Error(`Token not found: ${contractHash}`);
            }
        });
    }
}
exports.RpcNDSNeo3 = RpcNDSNeo3;
_RpcNDSNeo3_network = new WeakMap();
